import { logger } from 'src/commons/utils/logger';
import {
  interstitial_modal_fallback_url,
  resolveRemoteUrl,
} from 'src/remoteComponentEntries';

declare const __webpack_init_sharing__: (scope: string) => Promise<void>;
declare const __webpack_share_scopes__: { default: unknown };

const REMOTE_GLOBAL = 'AACInterstitialModal';
const REMOTE_MODULE = './InterstitialModal';

interface RemoteContainer {
  init: (shareScope: unknown) => Promise<void>;
  get: (module: string) => Promise<() => any>;
}

let scriptPromise: Promise<RemoteContainer> | undefined;

export const getRemoteEntryUrl = (): string => {
  const origin = resolveRemoteUrl(
    window?.__AAC_CHROME_REMOTE_URLS__?.interstitialModal,
    interstitial_modal_fallback_url,
  );
  return `${origin}/modal/remoteEntry.js`;
};

const loadRemoteEntry = (): Promise<RemoteContainer> => {
  if (scriptPromise) return scriptPromise;

  scriptPromise = new Promise<RemoteContainer>((resolve, reject) => {
    const existing = (window as any)[REMOTE_GLOBAL] as
      | RemoteContainer
      | undefined;
    if (existing) {
      resolve(existing);
      return;
    }

    const url = getRemoteEntryUrl();
    const script = document.createElement('script');
    script.src = url;
    script.type = 'text/javascript';
    script.async = true;

    script.onload = () => {
      const container = (window as any)[REMOTE_GLOBAL] as
        | RemoteContainer
        | undefined;
      if (container) {
        resolve(container);
      } else {
        reject(
          new Error(
            `InterstitialModal remote container not found on window after loading ${url}`,
          ),
        );
      }
    };

    script.onerror = () => {
      scriptPromise = undefined;
      reject(new Error(`Failed to load InterstitialModal remoteEntry: ${url}`));
    };

    document.head.appendChild(script);
  });

  return scriptPromise;
};

export const loadInterstitialRemote = async (): Promise<any> => {
  try {
    const container = await loadRemoteEntry();

    await __webpack_init_sharing__('default');
    await container.init(__webpack_share_scopes__.default);

    const factory = await container.get(REMOTE_MODULE);
    return factory();
  } catch (e) {
    logger.error(
      'Failed to load InterstitialModal remote: ',
      e instanceof Error ? e : new Error(String(e)),
    );
    throw e;
  }
};
